export function clamp(v: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, v));
}

/** 把全域進度 (0..MAX_SCROLL) 映射成某個場景自己的 0..1 進度。 */
export function sceneProgress(global: number, start: number, end: number): number {
  return clamp((global - start) / (end - start), 0, 1);
}

/** 場景進出場時使用的過場動畫字串。 */
export const TRANSITION =
  'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1)';

/** 品牌視覺色，統一沿用 Lighting River 的深藍 + 米白 + 青藍 + 暖琥珀。 */
export const COLORS = {
  bg: '#0A1A3A',
  bgDeep: '#071230',
  ink: '#0B1B3A',
  cream: '#F2EFE6',
  cyan: '#4FB3D9',
  amber: '#E0B15E',
  blue: '#1E4FA8',
  line: 'rgba(255,255,255,0.18)',
};